import { useTran } from "@/hooks";

const ESGReportCoverPage = ({ reportName, framework, notes, orgName }) => {
  const { t } = useTran();
  const currentDate = new Date().toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div className="esg-print-cover flex flex-col items-center justify-center bg-gradient-to-br from-emerald-50 to-blue-50 p-16 text-center">
      <div className="flex flex-1 flex-col items-center justify-center">
        <div className="mb-8 inline-block rounded-full bg-emerald-600 px-8 py-3 shadow-md">
          <span className="text-base font-semibold text-white tracking-wide">
            {t("{{framework}} Framework", { framework })}
          </span>
        </div>

        <h1 className="mb-6 max-w-4xl text-5xl font-bold leading-tight text-slate-900">
          {reportName || t("ESG Report")}
        </h1>
        {orgName ? (
          <p className="mb-2 text-xl font-semibold text-emerald-700">
            {t("Organization")}: {orgName}
          </p>
        ) : null}

        {notes ? (
          <p className="mx-auto max-w-2xl text-lg text-slate-600 leading-relaxed">
            {notes}
          </p>
        ) : null}
      </div>

      <div className="mt-auto text-base text-slate-500">
        <p>{t("Generated on {{date}}", { date: currentDate })}</p>
      </div>

      <div className="mt-16 max-w-2xl">
        <p className="text-sm text-slate-500 leading-relaxed">
          {t(
            "Prepared using data from our Environmental, Social, and Governance disclosure system in accordance with the {{framework}} reporting framework standards.",
            { framework },
          )}
        </p>
      </div>
    </div>
  );
};

export default ESGReportCoverPage;
